import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import { S as StepsWrapper } from './Steps.styles-D5Sg47XO.js';
import { S as STATUS } from './constants-uDs2MwW8.js';
import { I as Icon } from '../Icon/Icon-DowU4ANk.js';
import { c as check } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-B7bhIt-r.js';

class Steps extends PureComponent {
  render() {
    const {
      icons = {
        completed: /*#__PURE__*/React__default.createElement(Icon, {
          type: check
        })
      },
      numbered = true,
      children,
      initial = 0,
      current = 0,
      labelPlacement = 'horizontal',
      description = 'Steps',
      statusDescriptions = {
        completed: 'Completed step',
        active: 'Active step',
        future: 'Future step',
        disabled: 'Unavailable step'
      },
      isVertical = false
    } = this.props;
    const revisedLabelPlacement = isVertical ? 'horizontal' : labelPlacement;
    return /*#__PURE__*/React__default.createElement(StepsWrapper, {
      role: "list",
      "aria-label": description,
      $isVertical: isVertical
    }, React__default.Children.map(children, (child, index) => {
      if (! /*#__PURE__*/React__default.isValidElement(child)) {
        return null;
      }
      const stepNumber = initial + index;
      const childProps = {
        ...child.props,
        stepNumber: `${stepNumber + 1}`,
        stepIndex: stepNumber,
        icons,
        isVertical,
        numbered,
        labelPlacement: revisedLabelPlacement,
        statusDescriptions
      };
      if (!child.props.status) {
        if (stepNumber === current) {
          childProps.status = STATUS.ACTIVE;
        } else if (stepNumber < current) {
          childProps.status = STATUS.COMPLETED;
        } else {
          childProps.status = STATUS.FUTURE;
        }
      }
      childProps.active = stepNumber === current;
      return /*#__PURE__*/React__default.cloneElement(child, childProps);
    }));
  }
}
_defineProperty(Steps, "propTypes", {
  /**
   * The icons used in place of Steps.
   */
  icons: PT.objectOf(PT.node),
  /**
   * Denotes if the Steps should be numbered.
   */
  numbered: PT.bool,
  /**
   * The initial Step index.
   */
  initial: PT.number,
  /**
   * Denotes if the Steps should render vertically.
   */
  isVertical: PT.bool,
  /**
   * Index of current step.
   */
  current: PT.number,
  /**
   * Placement of step title.
   */
  labelPlacement: PT.oneOf(['horizontal', 'vertical']),
  children: PT.arrayOf(PT.node),
  /**
   * Use this prop to provide customized/localized steps description in internationalized UIs.
   * This will be used for screen reader labels.
   */
  description: PT.string,
  /**
   * Use this prop to provide customized/localized step descriptions in internationalized UIs for
   * active, completed, future, and disabled step status.
   * This will be used for screen reader labels in `<Step>` component.
   */
  statusDescriptions: PT.objectOf(PT.string)
});
_defineProperty(Steps, "defaultProps", {
  icons: {
    completed: /*#__PURE__*/React__default.createElement(Icon, {
      type: check
    })
  },
  numbered: true,
  initial: 0,
  isVertical: false,
  current: 0,
  labelPlacement: 'horizontal',
  children: [],
  description: 'Steps',
  statusDescriptions: {
    completed: 'Completed step',
    active: 'Active step',
    future: 'Future step',
    disabled: 'Unavailable step'
  }
});

export { Steps as S };
//# sourceMappingURL=Steps-BQ-uKY8_.js.map
